import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import { CourseSetDTO, LocationDTO, SiteDTO } from '@beable/roster-backend-client-v1';
import customerService from '../../../services/CustomerService';
import { getStyles } from './styles';

interface CourseSetTableProps {
    courseSets: CourseSetDTO[];
    sites: SiteDTO[];
    handleEditCourseSet: ((courseSetId: string) => void);
}

export default function CourseSetTable({ courseSets, sites, handleEditCourseSet }: CourseSetTableProps) {
  const theme = useTheme();
  const styles = getStyles(theme);
  const [locations, setLocations] = useState<LocationDTO[]>([]);

  useEffect(() => {
    const fetchLocations = async () => {
        const data = await customerService.getLocations();
        if (data) setLocations(data);
    };

    fetchLocations();
  }, []);

  const getLocationName = (locationCode: string) => {
    const location = locations.find(l => l.isoCode === locationCode);
    return location?.name;
  }

  const getSubdomain = (siteId: number) => {
    const site = sites.find(s => s.id === siteId);
    return site?.subdomain;
  }

  return (
    <TableContainer sx={styles.container}>
      <Table sx={styles.table} aria-label="course set table">
        <TableHead>
          <TableRow>
            <TableCell/>
            <TableCell sx={styles.tableCell}>Name</TableCell>
            <TableCell align="center" sx={styles.tableCell}>Location</TableCell>
            <TableCell align="center" sx={styles.tableCell}>Site</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {courseSets.map((courseSet) => (
            <TableRow key={courseSet.id}>
              <TableCell padding='checkbox'>
                <IconButton
                  aria-label="edit"
                  data-testid="edit-btn"
                  onClick={() => handleEditCourseSet(courseSet.id!)}
                  size="large">
                  <EditIcon fontSize="small"/>
                </IconButton>
              </TableCell>
              <TableCell component="th" scope="row" sx={styles.tableCell}>{courseSet.name}</TableCell>
              <TableCell align="center" sx={styles.tableCell}>{courseSet.locationCode ? getLocationName(courseSet.locationCode) : ''}</TableCell>
              <TableCell align="center" sx={styles.tableCell}>{courseSet.siteId ? getSubdomain(courseSet.siteId) : ''}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
